/**
 * Pivot Points Indicator
 *
 * Wraps the pivotPoints calculator and merges results into chart data.
 * Outputs 7 horizontal levels:
 * - pivot: Central pivot point
 * - r1, r2, r3: Resistance levels (above pivot)
 * - s1, s2, s3: Support levels (below pivot)
 */

import { rebind, merge } from "../utils";
import { pivotPoints } from "../calculator";
import baseIndicator from "./baseIndicator";

const ALGORITHM_TYPE = "PivotPoints";

export default function () {
  const base = baseIndicator()
    .type(ALGORITHM_TYPE)
    .accessor((d) => d.pivotPoints);

  const underlyingAlgorithm = pivotPoints();

  const mergedAlgorithm = merge()
    .algorithm(underlyingAlgorithm)
    .merge((datum, indicator) => {
      datum.pivotPoints = indicator;
    });

  const indicator = function (data, options = { merge: true }) {
    if (options.merge) {
      if (!base.accessor())
        throw new Error(
          `Set an accessor to ${ALGORITHM_TYPE} before calculating`,
        );
      return mergedAlgorithm(data);
    }
    return underlyingAlgorithm(data);
  };

  rebind(indicator, base, "id", "accessor", "stroke", "fill", "echo", "type");
  rebind(indicator, underlyingAlgorithm, "options", "undefinedLength");
  rebind(indicator, mergedAlgorithm, "merge", "skipUndefined");

  return indicator;
}
